import {useShifts} from "@/src/modules/shifts/hooks";
import {shiftsService} from "@/src/modules/shifts/services";

import {useActiveShift} from "./use-active-shift";

const OFFICER_OPTIONS = {
  filter: {
    upcoming: 1,
  },
  sort: "from_datetime",
  page: {
    offset: 0,
    limit: 4,
  },
};

/**
 * Derives next/upcoming from the same sources as the rest of the officer shell:
 * active shift from the `active-shift` query, upcoming rows from the `shifts` query payload.
 * Avoid reading Zustand here — after mutations, the store can lag one frame behind TanStack Query.
 */
export function useScheduledShifts() {
  const shiftsEnabled = shiftsService.getIsShiftsEnabledForRole();
  const {shift: activeShift} = useActiveShift();
  const {data: shiftsQueryData, ...query} = useShifts(OFFICER_OPTIONS, {
    // Upcoming list is home chrome only — compliance gates reconcile `active-shift` separately.
    refetchOnWindowFocus: false,
    enabled: shiftsEnabled,
  });

  const upcomingRows = shiftsQueryData?.shifts ?? [];

  const {nextShift, upcomingShifts} =
    query.isSuccess && shiftsQueryData
      ? activeShift
        ? {nextShift: null, upcomingShifts: upcomingRows}
        : {
            nextShift: upcomingRows[0] ?? null,
            upcomingShifts: upcomingRows.slice(1),
          }
      : {nextShift: null, upcomingShifts: []};

  return {
    ...query,
    nextShift,
    upcomingShifts,
    isPending: query.isPending && shiftsEnabled,
  };
}
